import React from 'react'
import Fade from 'react-reveal/Fade'
import FetchData from '../../../shared/fetchData'
import { updateObject } from '../../../shared/utility'
import Button from '../../UI/Button/Button'
import ContentForm from '../../UI/ContentForm/ContentForm'
import Input from '../../UI/Input/Input'
import Modal from '../../UI/Modal/Modal'
import TimePicker from "../../UI/TimePicker/TimePicker"
import './TariffCancelValueForm.css'

const TariffCancelValueForm = (props) => {

    const [loading, setLoading] = React.useState(false)
    const [edit, setEdit] = React.useState(false)
    const [changeForm, setChangeForm] = React.useState(false)
    const [id, setId] = React.useState('')
    const [tariffId, setTariffId] = React.useState('')
    const [invalidTime, setInvalidTime] = React.useState(false)
    const [tariffCancelValue, setTariffCancel] = React.useState({
        cancelPenaltyPercent: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'درصد جریمه کنسلی'
            },
            validation: {
                required: true
            },
            errorMessage: 'الزامی است',
            valid: true,
            value: ''
        },
        distanceFromTime: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'فاصله زمانی از'
            },
            validation: {
                required: true
            },
            errorMessage: 'الزامی است',
            valid: true,
            value: ''
        },
        distanceToTime: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'فاصله زمانی تا'
            },
            validation: {
                required: true
            },
            errorMessage: 'الزامی است',
            valid: true,
            value: ''
        },
    })

    const childRef = React.useRef()

    React.useEffect(() => {
        setTariffId(props.tariffId)
        if (props.edit == true) {
            const lckrTp = tariffCancelValue
            console.log(props)
            lckrTp.distanceFromTime.value = props.tariffCancelValue.distanceFromTime
            lckrTp.distanceToTime.value = props.tariffCancelValue.distanceToTime
            lckrTp.cancelPenaltyPercent.value = props.tariffCancelValue.cancelPenaltyPercent
            setTariffCancel(lckrTp)
            setEdit(true)
            setId(props.tariffCancelValue.id)
        }
    }, [])

    const inputChangedHandler = (event, controlName) => {
        const updatedControls = updateObject(tariffCancelValue, {
            [controlName]: updateObject(tariffCancelValue[controlName], {
                value: event.target.value
            })
        });
        console.log(updatedControls)
        setTariffCancel(updatedControls)
    }

    const tariffCancelValueSubmit = (event) => {
        const tv = tariffCancelValue
        let valid = true
        for (let key in tv) {
            if (tv[key].value == '') {
                valid = false
                tv[key].valid = false
            }
        }
        if (!valid) {
            setTariffCancel(tv)
            if (changeForm) {
                setChangeForm(false)
            } else {
                setChangeForm(true)
            }
        } else {
            if (!edit) {
                setLoading(true)
                const lckrTp = tariffCancelValue
                var raw = JSON.stringify({
                    "tariffCancelValue": {
                        "cancelPenaltyPercent": lckrTp.cancelPenaltyPercent.value,
                        "distanceFromTime": lckrTp.distanceFromTime.value,
                        "distanceToTime": lckrTp.distanceToTime.value,
                        "tariff": {
                            "id": tariffId
                        },
                    },
                    "version": "mtpx001"
                })

                var url = 'management/api/v1/tariffCancelValues/insertTariffCancelValue'
                FetchData(raw, url).then(response => response.json())
                    .then(result => {
                        setLoading(false)
                        if (result.status == 0) {
                            props.refreshTariffCancelValues()
                        } else {
                            childRef.current.openModal()
                        }
                    })
                    .catch(error => setLoading(false))
            } else {
                setLoading(true)
                const lckrTp = tariffCancelValue
                var raw = JSON.stringify({
                    "tariffCancelValue": {
                        "id": id,
                        "cancelPenaltyPercent": lckrTp.cancelPenaltyPercent.value,
                        "distanceFromTime": lckrTp.distanceFromTime.value,
                        "distanceToTime": lckrTp.distanceToTime.value,
                        "tariff": {
                            "id": tariffId
                        },
                    },
                    "version": "mtpx001"
                })

                var url = 'management/api/v1/tariffCancelValues/updateTariffCancelValue'
                FetchData(raw, url).then(response => response.json())
                    .then(result => {
                        setLoading(false)
                        if (result.status == 0) {
                            props.refreshTariffCancelValues(event, false)
                        }
                    })
                    .catch(error => setLoading(false))
            }
        }
    }

    const closeModal = (event) => {
        childRef.current.closeModal()
    }

    const afterCloseModal = (event) => {
    }

    const formElementsArray = [];
    for (let key in tariffCancelValue) {
        formElementsArray.push({
            id: key,
            config: tariffCancelValue[key]
        })
    }

    let form = formElementsArray.map(formElement => {
        return (
            <Input
                key={formElement.id}
                elementType={formElement.config.elementType}
                elementConfig={formElement.config.elementConfig}
                value={formElement.config.value}
                invalid={!formElement.config.valid}
                shouldValidate={formElement.config.validation}
                placeholder={formElement.config.placeholder}
                errorMessage={formElement.config.errorMessage}
                search={true}
                col="6 mt-2"
                changed={(event) => inputChangedHandler(event, formElement.id)} />
        );
    })

    const modalContent = <div>
        <div className='row justify-content-center'>
            رکورد مورد نظر تکراری است
        </div>
        <div className='row justify-content-center mt-3'>
            <Button btnType="Success" clicked={closeModal}>بستن</Button>
        </div>
    </div>

    return (
        <Fade duration={200} left cascade>
            <div className='row justify-content-center'>
                <div className='tariffCancelValue-cntnr'>
                    <ContentForm headetText='مقادیر تعرفه'>
                        <div className='tariffCancelValue-frm'>
                            <div className='row mr-0 ml-0 p-3'>
                                {form}
                            </div>
                        </div>
                        <div className='col-12'>
                            <div className='row justify-content-center w-100 mt-3'>
                                <div className='col-6 text-center'>
                                    <Button btnType="General" clicked={(event) => props.toggleNewLockerForm(event, false)}>برگشت</Button>
                                </div>
                                <div className='col-6 text-center'>
                                    <Button btnType="Success" clicked={tariffCancelValueSubmit}>ثبت</Button>
                                </div>
                            </div>
                        </div>
                    </ContentForm>
                </div>
            </div>
            <Modal
                content={modalContent}
                ref={childRef}
                closePermission="true"
                closeModal={(event) => afterCloseModal(event)}
            />
        </Fade>
    )
}

export default TariffCancelValueForm